import React, { createContext, useContext, useState, useEffect, useCallback } from "react";

// 3-theme system: default (classic gold) / vintage / youth.
// Switches document root data-theme + persists to localStorage.
const KEY = "ciao_theme";
const VALID = ["default", "vintage", "youth"];

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(() => {
    const s = typeof localStorage !== "undefined" ? localStorage.getItem(KEY) : null;
    return VALID.includes(s) ? s : "default";
  });

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
    localStorage.setItem(KEY, theme);
  }, [theme]);

  const setTheme = useCallback((t) => {
    if (VALID.includes(t)) setThemeState(t);
  }, []);

  return (
    <ThemeContext.Provider value={{ theme, setTheme, themes: VALID }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error("useTheme must be used within ThemeProvider");
  return ctx;
}
